<template>
  <div v-if="content" id="post-page" class="px-4" v-editable="content">
    <div class="flex items-center mt-12">
      <div class="relative inline-flex">
        <img loading="lazy" class="max-w-6xl max-h-96 mx-auto object-contain" :src="content.img" alt="">
        <div class="absolute top-0 left-0 py-3 md:py-4 px-3 md:px-6 bg-green-500 flex parallelogram">
          <span class="text-white font-bold z-10 relative">{{[date, "YYYY-MM-DDTHH:mm:ss.SSSZ"]| moment("Do MMMM YYYY")}}</span>
        </div>
      </div>
    </div>
    <div class="max-w-2xl mx-auto mt-6 md:mt-12">
      <div class="post-flex-end gap-6">
        <h1 class="font-luckiest text-2xl md:text-4xl text-primary" v-html="content.title"></h1>
        <img src="/img/leaf.png" class="w-12" loading="lazy" alt="">
      </div>
      <div class="h-1.5 bg-primary rounded-full w-full mt-2"></div>

      <div class="mt-4 md:mt-10">
        <vue-markdown v-if="content.subtitle" class="subtitle prose mb-4">{{content.subtitle}}</vue-markdown>
        <vue-markdown class="prose">{{content.text}}</vue-markdown>
      </div>
    </div>
    <BtnList :content="{btn:content.btns}"/>

    <h4 class="title center" v-html="$t('message.more')"></h4>
    <ul class="preview" v-if="latestPosts">
      <li :style="getBg(post.content.img)" v-for="(post,i) in latestPosts" :key="i">
        <router-link :to="`/${$i18n.locale}/blog/${post.slug}`">
          <h5 class="title" v-html="post.name"></h5>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import api from "@/api";
import VueI18n from "vue-i18n";
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  data() {
    return {
      id: this.$route.params.id,
      content: null,
      latestPosts: null,
      date: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    getBg(bg) {
      return {
        backgroundImage: `url(${bg})`
      };
    },
    async fetchData() {
      try {
        const resContent = await api.get(
          `cdn/stories/${this.$i18n.locale}/blog/${this.id}`
        );
        this.content = resContent.data.story.content;
        this.date = resContent.data.story.created_at;

        const resPost = await api.get(`cdn/stories`, {
          starts_with: `${this.$i18n.locale}/blog`,
          excluding_ids: resContent.data.story.id,
          sort_by: "created_at:desc",
          per_page: 2
        });
        this.latestPosts = resPost.data.stories;
      } catch (err) {
        this.$router.push("/404");
      }
    }
  }
};
</script>

<style lang="scss">
#post-page {
  iframe {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .markdown img {
    width: auto;
    margin-left: auto;
    margin-right: auto;
  }
  .post-content {
    width: $content-width;
    max-width: $max-width;
    margin: auto;
    background-color: #edefed;
    box-shadow: 0px 0px 30px 10px rgba(0, 0, 0, 0.15);
    position: relative;
    padding: 50px 30px;
    border-radius: 10px;
    overflow: hidden;
    h1 {
        font-size: 40px;
        padding: 0.5em 0;
      }
      h3 {
        font-weight:bold;
        margin-bottom:25px;
        margin-top:10px;
      }
      p {
        font-size: 20px;
        > img {
          max-width:500px;
          margin:auto;
        }
      }
    .subtitle {
      white-space: pre-wrap;
      p {
        font-weight: 800;
        font-size: 20px;
      }
    }
    .markdown {
      white-space: pre-wrap;
      line-height: 1.2;
    }
    .post-date {
      position: absolute;
      background-color: $primary;
      top: 0;
      right: 0;
      color: #fff;
      padding: 10px 15px;
      border-bottom-left-radius: 5px;
      font-weight: bold;
    }
  }
}
.preview {
  height: auto;
  width: $content-width;
  max-width: $max-width;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;
  padding-bottom: 40px;
  > li {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow: 0px 0px 30px 15px rgba(0, 0, 0, 0.15);
    //clip-path: polygon(10% 0, 90% 0, 100% 10%, 100% 90%, 90% 100%, 10% 100%, 0 90%, 0 10%);
    border-radius: 20px;
    overflow: hidden;
    transform: scale(1);
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.07);
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 1;
    }
    a {
      display: block;
      text-decoration: none;
      position: relative;
      z-index: 33;
      color: #fff;
      padding: 0 10px;
      h5 {
        color: #fff;
        text-align: center;
      }
    }
  }
}
@media screen and (max-width: $tablet) {
  #post-page {
    .preview {
      grid-template-columns: repeat(1, 1fr);
      > li {
        a {
          .title {
            font-size: 23px;
          }
        }
      }
    }
  }
}
</style>
